/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  UiLogin,
  UiCloseButton,
  UiMoeButton,
  UiLoginBox,
  UiLoginContent,
  UiHr,
  UiNaniAccount,
  UiTip,
  UiInputAccount,
  UiLoginButton,
  UiError,
} from './LoginPopup.style';
import { sendData,checkNaniOneClass } from "../../utils/hooks/login";
import useSetState from "utils/hooks/setState";

export const LoginPopup = (props) => {
  const [UserParams, setUserParams] = useState({
    Account: "",
    Password: "",
  });

  const [isLogin,setIsLogin] = useSetState(false)

  const [errormessage, seterrmessage] = useState("");

  useEffect(()=>{
    !isLogin&&checkNaniOneClass((res)=>{
      if(res){
        setIsLogin(true)
      }
    })
  })

  const Submit = useCallback(async (UserParams) => {
    if (UserParams.Account === "" || UserParams.Password === "") return false;

    const { code, message, jwt } = await sendData(
      UserParams.Account,
      UserParams.Password
    );
    if (jwt) {
      setIsLogin(true)
    } else {
      seterrmessage(message);
    }
  });

  const updateUserParams = (e) => {
    setUserParams({ ...UserParams,[e.target.name]: e.target.value });
  }

  return (
    <UiLogin style={{display:isLogin?'none':'flex'}}>
      <UiLoginBox>
        {/* <UiCloseButton className="Popup_loginPopup__close__1QLHE">
          <div className="line1"></div>
          <div className="line2"></div>
        </UiCloseButton> */}
        <h5>登入OneClub</h5>
        {errormessage ? (
          <UiError>{errormessage}</UiError>
        ) : (
          ""
        )}
        <UiLoginContent>
          {/* <UiMoeButton className="Popup_btnMoe__2Z9kN">
              <a className="btn btn-blue btn-block" href="https://oidc.tanet.edu.tw/oidc/v1/azp?client_id=2a50ca00dc7247f7b4e4443c3e5320ac&amp;nonce=e2f51fe4-a2e7-4bb3-8e0a-5c6da1acbb89&amp;redirect_uri=https%3A%2F%2Foneclub.oneclassName.com.tw%2Fsso%2Fmoe%2F&amp;response_type=code&amp;scope=openid%20openid%20email%20profile%20eduinfo&amp;state=e65e6b8e74cf432c8fce8058d8fc8299">
                <img src="/images/moe.png" height="24" width="24" alt="教育雲端帳號" />
                教育雲端帳號
              </a>
            </UiMoeButton>
            <UiHr></UiHr> */}
          <UiNaniAccount className="Popup_naniAccount__yLqpY">南一帳號</UiNaniAccount>
          <UiTip className="Popup_tip__3tH70">請輸入您的帳號及密碼</UiTip>
          <UiInputAccount className="Popup_loginPopup__inputbox__2cuXc">
            <img className="Popup_icon__1sHsB" src="/images/account.svg" height="20" width="20" alt="用戶名稱" />
            <div className="Input_inputWrapper__2LFOb">
              <label>
                <input
                  type="text"
                  name="Account"
                  placeholder="請輸入您的用戶帳號"
                  value={UserParams.Account}
                  onChange={(e)=>updateUserParams(e)}
                />
              </label>
            </div>

          </UiInputAccount>
          <UiInputAccount className="Popup_loginPopup__inputbox__2cuXc">
            <img className="Popup_icon__1sHsB" src="/images/password.svg" height="20" width="20" alt="密碼" />
            <div className="Input_inputWrapper__2LFOb">
              <label>
                <input
                  type="password"
                  name="Password"
                  placeholder="請輸入您的用戶密碼"
                  value={UserParams.Password}
                  onChange={(e)=>updateUserParams(e)}
                />

              </label>
            </div>
          </UiInputAccount>
          <UiLoginButton
            className="login"
            onClick={() => Submit(UserParams)}
          >
            <span>登入</span>
          </UiLoginButton>
        </UiLoginContent>
      </UiLoginBox>

    </UiLogin>
  );
};
LoginPopup.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
};
